import { parsePhoneNumberFromString } from "libphonenumber-js";

export function getCountryCodeAndNumber(phone) {
  if (!phone) {
    return {
      countryCode: '+1',
      phoneNumber: '',
      country: '',
    };
  }
  const phoneNumber = parsePhoneNumberFromString(phone);

  return {
    countryCode: `+${phoneNumber.countryCallingCode}`,
    phoneNumber: phoneNumber.nationalNumber,
    country: phoneNumber.country,
  };
}
